import { adresGetAdres } from '@services/crm-public/orval-api/adres/adres';
import { type CrmAdressenZoekEnMaakAdresAdresMetToevoegingen } from './orval-api/model/crmAdressenZoekEnMaakAdresAdresMetToevoegingen';

export type AdresResult = {
  success: boolean;
  adres?: CrmAdressenZoekEnMaakAdresAdresMetToevoegingen;
  error?: string;
};

export const getAdres = async (
  postcode: string,
  huisnummer: number,
  huisnummerToevoeging?: string,
) => {
  try {
    const { result } = await adresGetAdres({
      postcode,
      huisnummer,
      toevoeging: huisnummerToevoeging,
    });

    return { success: true, adres: { ...result } };
  } catch (error) {
    return {
      success: false,
      error:
        (error as any)?.data?.title ??
        'Er is een onverwachte fout opgetreden bij het ophalen van het adres',
    };
  }
};
